// Si se quiere agregar un permiso, se debe agregar en este archivo tanto en back como en front. Con el id que se genere en base de datos.
// En el front se tratan los id en uppercase y en back en lowercase. Preguntar por esto
export const PERMISOS = {
    // VISOR DEL MAPA
    VISUALIZAR_INCIDENTES: "9CBCAA8F-A434-41A0-B75F-020C9C3F7B4A",
    VISUALIZAR_MEDIOS_ACTIVOS: "83FC2B47-3D6E-4E30-8446-05937015D275",
    VISUALIZAR_MEDIOS_INACTIVOS: "77FD001F-7A08-4F31-8A31-05C81A3CBA21",
    VISUALIZAR_ETIQUETAS: "80C52CA5-DC00-4625-AC35-0BFD4A41483F",
    VISUALIZAR_FILTROS_ORGANISMOS: "81743219-68D1-4C8E-AD88-0F57F6D94E5A",
    VISUALIZAR_HOJA_GUARDIAS: "714DB060-B76D-4385-93CF-1423C97D835D",
    VISUALIZAR_GESTION_MEDIOS: "BE27FFE9-C831-4277-8292-1B539C61826D",
    VISUALIZAR_GESTION_INFRAESTRUCTURAS: "E43470E7-CFA7-4F46-AD1F-21F1D458AA70",
    VISUALIZAR_HISTORICO_TRACKS: "5C3D37FA-B304-45CC-A5C8-23EA0CA34F7A",
    VISUALIZAR_GESTION_INCIDENTES: "EB83D931-2C21-443D-B690-2608E339BB7F",
    VISUALIZAR_PARAMETROS_GENERALES: "5144023D-4954-47AF-880F-2A99E3266256",
    VISUALIZAR_RESUMEN_RECURSOS: "E62A6FBF-CA87-40DE-B6FD-31442818A4D5",
    // GESTION DE GUARDIAS
    VER_TURNOS: "DE2E042C-5861-467A-B6F5-324E68C20269",
    ADMINISTRAR_TURNOS: "5F087431-9208-4627-812F-4363A794EB4B",
    VER_HOJA_GUARDIAS: "BD57907B-1F34-4355-99B5-461664DD26F6",
    DUPLICAR_HOJA_GUARDIAS: "C4318154-2173-43F8-A4A3-4FAE312151B9",
    LIMPIAR_HOJA_GUARDIAS: "C3DAD4F5-BB7F-4376-99E6-537105A40587",
    ADMINISTRAR_HOJA_GUARDIAS: "5BECB1DF-1627-435F-A57C-55E4D1B932EA",
    // GESTION DE INFRAESTRUCTURAS
    VER_INFRAESTRUCTURAS: "E4528E48-BBB6-47BC-A7D6-5FAECDD8615D",
    ADMINISTRAR_INFRAESTRUCTURAS: "2F25F785-3518-4B1C-86A0-6064DBF94346",
    // GESTION DE MEDIOS
    VER_RECURSOS: "418A7F5E-775F-4E73-BBF7-638390B96CE4",
    ADMINISTRAR_RECURSOS: "8FDAFB94-1D4A-4650-8CBD-71CEC2D891DC",
    VER_PERSONAL: "17B01551-EEB8-45EE-948D-74B84AF8E672",
    ADMINISTRAR_PERSONAL: "6A316A41-52E2-41EA-8A31-76EB9A231E8B",
    VER_EQUIPOS: "1880E79D-7FA3-4EE6-9B20-7DB02FF3F97E",
    ADMINISTRAR_EQUIPOS: "3EE61362-36E5-4A5C-81BC-880A0375C74C",
    VER_HISTORICO_RECURSO: "1F64F143-EC65-4F39-BA71-68933A7C27E2",
    EDITAR_HISTORICO_RECURSO: "472FCA2D-BEAF-42DA-93DB-11F83C66473F",
    // GESTIÓN DE TRACKS
    PERMITIR_DESCARGAS: "F07AAAD9-0718-475B-A22A-89EA25F65268",
    // GESTIÓN DE ROLES
    VER_ROLES: "5F57D733-60D1-420E-9134-8ABEECD388F9",
    ADMINISTRAR_ROLES: "3B476D3D-7CB5-43EE-A65A-8CC3C2B550BD",
    VER_USUARIOS: "5282E0A1-F854-4671-AFFE-93484D23A059",
    ADMINISTRAR_USUARIOS: "7CB821BD-C34E-4F17-82C1-96A84B24A8CC",
    // GESTIÓN DE INCIDENTES
    PERMITIR_OCULTAR: "47820FB8-128B-45F5-A1FD-A358878DB134",
    PERMITIR_HISTORICO_INCIDENTE: "A9EA7206-2BA0-4F5A-9B70-AA4D20B2DB6E",
    PERMITIR_INFORME_INCIDENTE: "2558C6E6-CAE6-4B50-BF47-B32A6B7507A6",
    PERMITIR_ELIMINAR_INCIDENTE: "5CC5B955-38B9-4898-AF7C-B6121583E7FC",
    // GESTIÓN RESUMEN DE RECURSOS
    PERMITIR_DESPACHO_RECURSOS: "1BE6E4AD-8CEB-4592-AE5F-B69157435F3E",
    // EDICIÓN DE UN INCIDENTE
    CREAR_INCIDENTE: "59D42B17-7592-40A4-8E8B-B90C7E1F9ACE",
    VER_DATOS_INCIDENTE: "557BCFE8-8428-4D3D-AF81-B98D90AB5C1B",
    EDITAR_DATOS_INCIDENTE: "24A7B7C5-BF13-4F1E-8E04-BE260FEC341A",
    PERMISO_TRACKS_MEDIOS_ASOCIADOS: "FA29356B-2192-4E51-BEFC-C784EEFCCA4A",
    PERMISO_INFORME_POSICIONES: "8F28639D-32FF-42C8-995A-C7B434988780",
    PERMISO_INFORME_INCIDENTE: "2750D2CD-A3C2-4BBD-9968-D0E7FFBA59CF",
    PERMISO_INFORME_RECURSOS: "BAE57689-7AB2-49F9-BB86-D17C47E0B6FC",
    PERMISO_SUBIR_IMAGENES: "CA03A7DE-C61E-48AE-9389-D6C373C4FBAF",
    PERMISO_ELIMINAR_INCIDENTE: "C55D1175-C2CD-48AC-ABC7-D746104DA4B8",
    PERMISO_SITUACION_OPERATIVA: "5E1716C9-0637-4536-8231-E33BFC1F09B1",
    PERMISO_GESTION_DIRECTORES: "333AF104-84EA-433C-8D33-EAFE72805BDD",
    PERMISO_MODIFICAR_ESTADO: "26BB9E88-F8A0-41F1-9BA8-EB1E8E108883",
    PERMISO_EDITAR_SECTORES: "96BA8610-B903-46ED-8DA5-EBC3406A396D",
    PERMISO_DESPACHAR_RECURSO: "066BEA20-F272-44F6-8B7A-EE09A29AC80C",
    VER_PLANES_OPERACIONES: "5E19621D-3D7E-4765-B345-F269304B9FC5",
    ADMINISTRAR_PLANES_OPERACIONES: "518F8741-A706-4957-BF48-F3034DDB4770",
    VER_PERIMETROS: "B8C674E4-D17F-4841-BA66-F361417DFDDD",
    ADMINISTRAR_PERIMETROS: "38612E41-EB3E-4BAD-B066-F6585EC3F64D",
    VER_IMAGENES_SATELITE: "18C0365D-A31A-48B0-9ED9-F788C78C2CBE",
    ADMINISTRAR_IMAGENES_SATELITE: "86FECAE2-DF41-468D-854C-FD30AD547A7E",
    // GESTIÓN DE DISPOSITIVOS DE SEGUIMIENTO
    VISUALIZAR_GESTION_DISPOSITIVOS_SEGUIMIENTO: '83E8BBB7-3411-478F-BF53-B875CE104A8D',
    ADMINISTRAR_DISPOSITIVOS_SEGUIMIENTO: 'E728B330-F164-49C1-B92F-BC7248A8F27C',
    // DASHBOARDS
    VISUALIZAR_DASHBOARDS: '23A2D4E9-9C51-4AD3-8738-8890A61B0EF2',
    // PLANIFICACIÓN
    VISUALIZAR_PLANIFICACION: 'C94875B9-9829-473F-B246-235110E5F8AB',
    // SIMULACION
    VISUALIZAR_SIMULACION: '04E554CC-8827-4BA3-94C8-11973506AFAB',
    // GEOFENCING
    VISUALIZAR_GEOFENCING: '6F44016D-CF43-45D7-9AF4-57608F7271C4'
};
// Invertimos el diccionario para obtener nombre por ID en mayúsculas
export const PERMISO_NOMBRE_POR_ID = Object.fromEntries(Object.entries(PERMISOS).map(([nombre, id]) => [id.toUpperCase(), nombre]));
